import { contactsListEmptyNoticeColors } from '~/pages/Contacts/componentStyles/ContactsListEmptyNotice.colors'
import { createColorKeys } from '~/utils/chakraUtils'

import { contactItemColors } from './ContactItem.colors'
import { contactsDetailViewColors } from './ContactsDetailView.colors'
import { contactSourceColors } from './ContactSource.colors'

export const contactsColors = {
  Contacts: {
    ContactItem: contactItemColors,
    ContactsDetailView: contactsDetailViewColors,
    ContactSource: contactSourceColors,
    ContactsListEmptyNotice: contactsListEmptyNoticeColors,
  },
}

export const contactsColorKeys = createColorKeys(contactsColors)
